import { IFinancialLineItemComponent } from '@modeso/types__aumico-lib-annualreport-be';
export interface IFinancialLineItemDelegate {
    fliComponentData(fliData: IFinancialLineItemComponent, componentIndex: number);
}
